/**
 * contactEditor.js
 * import axios for server calls
 * import Form is used for form fields and styling
 * import Button is the button field from react bootstrap
 * import Row and Col from react bootstrap for organizing display
 * import ErrorMessage for displaying error messages
 */
import React, {useEffect, useState} from "react";
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import "../../style/creationstyle.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import ErrorMessage from '../Misc/ErrorMessage';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/**
 * this is the contact editor. takes in name and emails from user then
 * sends the info to backend for saving
 * 
 * returns a form that displays the contact editor 
 * @param getContact = function to get user's contacts
 * @param editContactData = keeps track if form is editing contact or creating new contact
 * @param assignedEvent = event id
 * @param editContact = function to edit contact info
 */
function ContactEditor({getContact, editContactData, assignedEvent, editContact}) {
    const[editorName, setEditorName] = useState("");
    const[editorEmail, setEditorEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    
    
    useEffect(() => {
        if(editContactData) {
            setEditorName(editContactData.name);
            setEditorEmail(editContactData.email);
        }
    }, [editContactData]);

    /**
     * takes form data and sends to backend for saving
     */
    async function saveContact(e) {
        e.preventDefault();
        //creating a contact field to be sent
        const contactData = {
            name:editorName,
            email: editorEmail,
            eventID: assignedEvent
        };

        //If creating contact will just post the updated info
        if(!editContactData) {
            try {
            await axios.post("https://link2rsvp.herokuapp.com/contact/", contactData);
            clearEditor();
            getContact();
            } catch (err) {
                if(err.response) {
                    if(err.response.data.errorMessage) {
                        setErrorMessage(err.response.data.errorMessage);
                    }
                }
            }
        }
        //If editing contact will send new info to be created
        else {
            try {
            await axios.put(`https://link2rsvp.herokuapp.com/contact/${editContactData._id}`, contactData);
            clearEditor();
            getContact();
            } catch (err) {
                if (err.response) {
                    if (err.response.data.errorMessage) {
                        setErrorMessage(err.response.data.errorMessage);
                    }
                }
            }
        }
    }
    //clears the editor form
    function clearEditor() {
        //setContactEditorOpen(true);
        setEditorName("");
        setEditorEmail("");
        editContact(null);
    }

    return (
        <div>
            {
            //form on submit calls savedContact to process data
            }
            {
                errorMessage && (
                    <ErrorMessage
                    message={errorMessage}
                    clear={() => setErrorMessage(null)}
                    />
                )}
            <form onSubmit={saveContact}>

        <Form.Group className="mb=3">
            <Form.Label htmlFor="editor-name">Name</Form.Label>
            <Form.Control 
            id="editor-name"
            type="text"
            value={editorName}
            onChange={(e) => setEditorName(e.target.value)}
            />
        </Form.Group>

        <Form.Group className="mb=3">
            <Form.Label htmlFor="editor-email">Email</Form.Label>
            <Form.Control 
            id="editor-email"
            type="email"
            value={editorEmail}
            onChange={(e) => setEditorEmail(e.target.value)}
            />
        </Form.Group>
        <Row>
            <Col><Button variant="secondary" type="submit" id="add-con">Add Contact</Button></Col>
            <Col><Button variant="dark" onClick={clearEditor} id="cancel-con">Cancel</Button></Col>
        </Row>
            </form>
        </div>
    )

}

export default ContactEditor;